import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import RuleForm from '../inputs/RuleForm';
import InlineRegionSelect from '../inputs/InlineRegionSelect';


const PendingClinicRule = (props) => {
  const {
    form, onSubmit, initialValues, ...other
  } = props;
  const [regions, setRegions] = useState(
    !_.isEmpty(initialValues.regions) ? initialValues.regions : [0]
  );

  const submit = useCallback((event) => {
    event.preventDefault();
    onSubmit({
      kind: 'pending_clinic',
      value: {}
    });
  }, [onSubmit, regions]);

  const onReset = useCallback(() => {
    setRegions(
      !_.isEmpty(initialValues.regions) ? initialValues.regions : [0]
    );
  }, [initialValues.regions]);


  return (
    <RuleForm
      {...other}
      onSubmit={submit}
      onReset={onReset}
      isSubmitting={form.is_submitting}
    />
  );
};

PendingClinicRule.defaultProps = {
  initialValues: {}
};

PendingClinicRule.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  initialValues: PropTypes.object,
};

export default PendingClinicRule;
